class FacetSort extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', e => {
      if (!e.target.closest(this.els?.trigger?.selector)) return

      const triggerEl = e.target.closest(this.els.trigger.selector)
      this.formSort.value = triggerEl.dataset.value

      this.formSort.dispatchEvent(new Event('input', { bubbles: true }))

      this.els.trigger.elements.forEach(trigger => {
        if (trigger === triggerEl) {
          trigger.setAttribute('aria-current', 'page')
        } else {
          trigger.removeAttribute('aria-current')
        }
      })
    })
  }

  get formSort () {
    const selector = '[data-collection-filters-form-el="sort"]'

    return document.querySelector(selector)
  }
}

if (!customElements.get('facet-sort')) {
  customElements.define('facet-sort', FacetSort)
}
